module.exports = __webpack_public_path__ + "media/images/circled-plus-8c04daea4a4cc167a7148f88e62b5d06.svg";